import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_rate",
  "use": "icon-control_rate-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_rate\"><path d=\"M8 2.13l1.725 3.495 3.858.561-2.792 2.721.66 3.842L8 10.935 4.55 12.75l.659-3.842-2.792-2.721 3.858-.56L8 2.13z\" stroke=\"currentColor\" fill=\"transparent\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol